import RegisterForFreeMobile from "./RegisterForFreeMobile";
import RegisterForFreeDesktop from "./RegisterForFreeDesktop";
import useMediaQuery from "../common/hooks/useMediaQuery";
import { MEDIA_QUERY_MIN_DESKTOP_S } from "../utils/screenSizes";

export const RegisterForFreePage = ({ showCustomerRegistration }: { showCustomerRegistration?: boolean }) => {
  const isDesktop = useMediaQuery(MEDIA_QUERY_MIN_DESKTOP_S);

  return isDesktop ? (
    <RegisterForFreeDesktop showCustomerRegistration={showCustomerRegistration} />
  ) : (
    <RegisterForFreeMobile showCustomerRegistration={showCustomerRegistration} />
  );
};
